<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <div class="row">
          <div class="col-sm-6">
            <h3>{{$t("targetgroups")}}</h3>
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a>{{$t("general")}}</a></li>
              <li class="breadcrumb-item active">{{$t("targetgroup_management")}}</li>
            </ol>
          </div>
          <div class="col-sm-6">
            <!-- Bookmark Start-->
            <div class="bookmark">
              <ul>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Tables"><i data-feather="inbox"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Chat"><i data-feather="message-square"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Icons"><i data-feather="command"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Learning"><i data-feather="layers"></i></a></li>
                <li><a href="javascript:void(0)"><i class="bookmark-search" data-feather="star"></i></a>
                  <form class="form-inline search-form">
                    <div class="form-group form-control-search">
                      <input type="text" :placeholder="$t('search') + '...'">
                    </div>
                  </form>
                </li>
              </ul>
            </div>
            <!-- Bookmark Ends-->
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="col-md-12 p-0 project-list">
        <div class="card">
          <div class="row">
            <div class="col-md-6 p-0">
              <div class="mb-2">
                <input class="form-control" type="text" v-model="search" @change="fetchTargetgroups(true)"
                  :placeholder="$t('search') + '...'">
              </div>
            </div>
            <div class="col-md-6 p-0">
              <div class="form-group mb-0 me-0"></div>
              <a class="btn btn-primary-light" @click="$router.push('/create-targetgroup')"> <plus-square-icon
                  class="custom-class"></plus-square-icon>{{$t("CREATE_NEW_TARGETGROUP")}}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">{{$t("app")}}</th>
                    <th scope="col">{{$t("name")}}</th>
                    <th scope="col" v-show="$rights.includes('TENANT_INDEPENDENCE')">{{$t("tenant")}}</th>
                    <th scope="col">{{$t("actions")}}</th>
                  </tr>
                </thead>
                <tbody v-if="targetgroups.length > 0">
                  <tr v-for="targetgroup in targetgroups" :key="targetgroup.id">
                    <td class="align-middle" v-if="targetgroup.app != null"><v-img class="rounded-lg" :src="`/files/images/${targetgroup.app.icon}`" width="50" :aspect-ratio="1"></v-img>
                    </td><td v-else></td>
                    <td>{{ targetgroup.name }}</td>
                    <td v-show="$rights.includes('TENANT_INDEPENDENCE')">{{ targetgroup.tenant == null ? "" : targetgroup.tenant.name }}</td>
                    <td>
                      <button class="btn btn-light"
                        @click="$router.push('/edit-targetgroup?targetgroupId=' + targetgroup.id)">
                        <edit-icon size="16"></edit-icon></button>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <td colspan="5">{{ $t("no_entries") }}</td>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="position:absolute; bottom: 100px;left:50%;height:40px;width:40px "
      v-intersect.quiet="infiniteScrolling"></div>
    <!-- Container-fluid Ends-->

  </div>
</template>

<script>

import pagination from './custom/pagination.vue'
import { CalendarIcon,MapPinIcon, PlusSquareIcon, ClipboardIcon, FileTextIcon, TrashIcon, EditIcon } from 'vue-feather-icons'

export default {

  components: {
    MapPinIcon,
    PlusSquareIcon,
    ClipboardIcon,
    FileTextIcon,
    TrashIcon,
    EditIcon,
    CalendarIcon,
  },

  data() {
    return {
      page: 1,
      totalPages: 1,
      ElementPerPage: 50,
      sort: null,
      order: true,
      routes: {
        targetgroups: "/api/targetaudience",
        filter: "/api/targetgroups/search/"
      },
      search: "",
      convertedTenants: [],
      tenantFilter: null,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      rules: [(value) => !!value || this.$t("required")],
      targetgroups: [],
      roles: [],
      createTenantPopup: false,
      menu: false,
      createmode: true,

      // Personal Data
      me: null,
    };
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },

  mounted() {
    this.fetchTargetgroups();
  },

  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
      if (isIntersecting) {
        setTimeout(() => {
          var _this = this;
          if (this.page < this.totalPages) {
            this.page++;
            this.$axios
              .get(this.routes.targetgroups, {
                params: {
                  sort: this.sort,
                  order: this.order ? "ASC" : "DESC",
                  page: this.page - 1,
                  size: this.ElementPerPage
                }
              })
              .then(function (response) {
                if (response.data.content.length > 1) {
                  response.data.content.forEach(item => _this.targetgroups.push(item));
                  _this.totalPages = response.data.totalPages;
                }
              })
              .catch(this.onError);
          }
        }, 500);
      }
    },
    previousPage() {
      this.page = this.page - 1;
      this.fetchTargetgroups();
    },
    nextPage() {
      this.page = this.page + 1;
      this.fetchTargetgroups();
    },
    onError(err) {
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
      }
    },
    fetchTargetgroups(resetPage = false) {
      if (resetPage) this.page = 1;
      var _this = this;
      this.$axios
        .get(this.routes.targetgroups, {
          params: {
            search: _this.search,
            sort: _this.sort,
            order: _this.order ? "ASC" : "DESC",
            page: _this.page - 1,
            size: _this.ElementPerPage
          }
        })
        .then(function (response) {
          _this.targetgroups = response.data.content;
          _this.totalPages = response.data.totalPages;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    updatePage() {
      this.fetchTargetgroups();
    },
    updateVisibleTargetgroups() {
      var _this = this;
      this.targetgroups = this.targetgroups.slice(
        (_this.page = _this.ElementPerPage),
        (_this.page = _this.ElementPerPage) + _this.ElementPerPage
      );

      if (this.targetgroups.length == 0 && this.page > 0) {
        this.updatePage(this.page - 1);
      }
    },

    tableRowClicked(tenantId) {
      if (this.$rights.includes('EDIT_CUSTOMERS') || this.$rights.includes('TENANT_INDEPENDENCE')) {
        this.$router.push('/edit-tenant?tenantId=' + tenantId)
      }
    },
    getJsonOptions() {
      const options = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      return options;
    },
  },
};
</script>

<style scoped>
.v-dialog>.v-card>.v-card__actions {
  padding: 8px 16px;
}
</style>

